import { render, staticRenderFns } from "./ImportBatch.vue?vue&type=template&id=6c370c5f&scoped=true&"
import script from "./ImportBatch.vue?vue&type=script&lang=ts&"
export * from "./ImportBatch.vue?vue&type=script&lang=ts&"
import style0 from "./ImportBatch.vue?vue&type=style&index=0&id=6c370c5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c370c5f",
  null
  
)

export default component.exports